<section class="mu-home font-size-14" *ngIf="queryDetailsForm">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <form [formGroup]="queryDetailsForm">
            <div class="row">
              <div class="col-md-12 text-end">
                <a>
                  <button type="button" class="btn-actvtytp" (click)="downloadQuery()">DOWNLOAD</button>
                </a>
              </div>
              <div class="col-md-12 mb-2 empl-tptxt">
                <h3 class="mb-0">View/Update Query Details</h3>
              </div>
              <div class="row row-cols-6">
                <div class="col-md-6 col-12">
                  <div class="row p-2">
                    <div class="col-4">Query ID</div>
                    <div class="col">{{ f.displayId.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Query Name</div>
                    <div class="col">{{ f.title.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Category</div>
                    <div class="col">{{ this.query?.taskCategory }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Description</div>
                    <div class="col" style="white-space: pre-line; word-break: break-all">
                      {{ f.description.value }}
                    </div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Query Raised On</div>
                    <div class="col">{{ f.createdDatetime.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Current Status</div>
                    <div
                      class="col">{{ statusLabel }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Response Due by</div>
                    <div class="col">{{ f.responseDueDatetime.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Next Action By</div>
                    <div class="col">{{ f.nextAction.value }}</div>
                  </div>
                  <div class="row p-2">
                    <div class="col-4">Dept Timeline</div>
                    <div class="col">{{ f.epfoTimeline.value }}</div>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="col-12">
                    <app-comment
                      [comments]="query?.comments"
                      [disableAddComment]="!isQueryUnlocked"
                      (add)="addComment($event)"
                      (notifyChange)="getIfNotifySelected($event)"
                    >
                    </app-comment>
                  </div>
                  <div class="col-12">
                    <p class="side-panel-label">Upload Documents</p>
                    <app-multiple-file-selector
                      (chooseFiles)="handleFileInput($event)"
                      (removeFiles)="clearSelectedFiles($event)"
                    ></app-multiple-file-selector>
                  </div>
                  <div class="col-12">
                    <div class="p-2">
                      <app-attachment-list
                        [referenceId]="id"
                        [canDownloadAll]="true"
                        [attachments]="query?.documents"
                        [companyEntityId]="query?.companyEntityId"
                      ></app-attachment-list>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 d-flex justify-content-end acvtypglastbtn">
                <a>
                  <button type="button" class="btn" (click)="updateQuery()" *ngIf="isQueryUnlocked">SAVE & EXIT</button>
                </a>
                <a>
                  <button type="button" class="btn-discard" [routerLink]="QUERY_DASHBOARD_LINK">EXIT</button>
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
